import { abruptCutAPIs } from "./abruptCutAPIs";

const audioCutAPI = {
  ...abruptCutAPIs,
};
export default audioCutAPI;
